import {GO_LINK_HOST, GO_LINK_HOST_DEV} from '@/app/main/split-bills/constants';
import {isProduction} from '@/utils/environment';

type BuildAdjustLinkArgs = {
  path: string;
  fallbackUrl: string;
  adjT: string;
  extraQueryParams?: Record<string, string | number | boolean | undefined>;
};

export const buildAdjustLink = ({
  path,
  fallbackUrl,
  adjT,
  extraQueryParams,
}: BuildAdjustLinkArgs): string => {
  const env = isProduction ? GO_LINK_HOST : GO_LINK_HOST_DEV;

  const queryParams = new URLSearchParams({
    adj_t: adjT,
    adj_redirect: fallbackUrl,
  });

  if (extraQueryParams) {
    Object.entries(extraQueryParams).forEach(([key, value]) => {
      if (value === undefined) return;
      queryParams.set(key, String(value));
    });
  }

  return `${env}/${path}?${queryParams.toString()}`;
};
